/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

import database from '../firebase/database';
import firestore from '../firebase/firestore';
import storage from '../firebase/storage';
import tripModule from './trip';
import firChat from '../firebase/chat';

console.log("init store.js");

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { trip: tripModule },
  state: {
    firUser: null,
    currentUser: null,
    users: {},
    userTrips: [],
    companies: {},
    companiesPrivate: {},
    imageUrls: {},
    obtainedCompanies: false,

  },
  mutations: {
    firUserUpdated: (state, user) => {
      state.firUser = user;
    },
    currentUserUpdated: (state, currentUser) => {
      state.currentUser = currentUser;
    },
    updateValue: (state, payload) => {
      state[payload.collection] = payload.value;
    },
    updateCollectionDocument: (state, payload) => {
      Vue.set(state[payload.collection], payload.document.id, payload.document);
    },
    deleteCollectionDocument: (state, payload) => {
      Vue.delete(state[payload.collection], payload.documentId);
    },
    updateDatabaseChild: (state, payload) => {
      Vue.set(state[payload.collection], payload.document.id, payload.document.value);
    },
    tripsUpdated: (state, trips) => {
      state.userTrips = trips;
    },
    newUrl: (state, url) => {
      Vue.set(state.imageUrls, url.id, url.url);
    },
    logOut: (state) => {
      state.firUser = null;
      state.currentUser = null;
      state.obtainedCompanies = false;
      state.companies = {};
      state.companiesPrivate = {};
      state.userTrips = [];
    },
    deleteTripUsers: (state, userIds) => {
      const currentUserId = state.firUser?.uid;
      userIds.forEach((userId) => {
        if (currentUserId !== userId) {
          Vue.delete(state.users, userId);
        }
      });
    },
  },
  getters: {
    getUserById: (state) => (id) => state.users[id] || {},
    userShortName: (state) => (id) => ((state.users[id] || {}).name || "").split(" ").shift(),
    getImageUrlById: (state) => (id) => state.imageUrls[id],
    activeTrips: (state) => state.userTrips.filter((trip) => trip.archived !== true),
  },
  actions: {
    logOut: (context, user) => {
      database.stopObservingUser(user.uid);
      database.stopObservers();
      firChat.stopObservers();
      firestore.unsubscribeListeners();
      const { trip } = context.state.trip;
      if (trip) {
        const userIds = Object.keys(trip.user_ids);
        context.commit('deleteTripUsers', userIds);
      }
      context.commit("deleteTrip");
      context.commit('logOut');
    },
    userLogedIn: (context, user) => {
      database.observeCurrentUser(context, user);
      context.dispatch('getCompanies', user);
    },
    getCompany: (context, companyId) => {
      firestore.getCompany(context, companyId);
    },
    getCompanies: (context, user) => {
      firestore.getCompanies(context, user.uid);
    },
    observeCompanyUsers: (context, company) => {
      console.log('observing company users');
      if (context.state.firUser.uid === company.owner) {
        console.log(context.state.firUser.uid, "is the owner of", company.id);
        firestore.listenCompanyPrivate(context, company.id);
      }
      database.observeUsers(context, company.admins);
    },
    getTrips: (context) => {
      firestore.listenTrips(context, context.state.firUser.uid);
    },
    getImageUrl: (context, object) => {
      // console.log('getting url for path', object.path, object.id)
      storage.getDownloadURL(object.path).then((url) => {
        context.commit('newUrl', { id: object.id, url });
      }).catch((error) => {
        console.log(error.message);
      });
    },
  },
});
